import "./facets";
import "./filter-drawer";

document.addEventListener("DOMContentLoaded", () => {
  const grid = document.getElementById("ProductGridContainer");
  const sentinel = document.getElementById("product-grid-sentinel");
  const sectionId = grid?.dataset.sectionId;
  const productGridSection = document.getElementById("product-grid-section");
  const productCount = parseInt(productGridSection?.dataset.productCount || "0", 10);

  if (!grid || !sentinel || !sectionId) return;

  let currentPage = 1;
  let loading = false;

  // Use a larger rootMargin for collections with more than 50 products
  // to start loading the next page earlier
  const rootMargin = productCount > 50 ? "1500px" : "300px";

  const observer = new IntersectionObserver(loadMore, {
    rootMargin,
  });

  observer.observe(sentinel);

  async function loadMore(entries) {
    if (!entries[0].isIntersecting || loading) return;

    loading = true;
    observer.unobserve(sentinel);

    try {
      const baseUrl = window.location.pathname + window.location.search;
      const url = new URL(window.location.origin + baseUrl);
      currentPage += 1;
      url.searchParams.set("page", currentPage);
      url.searchParams.set("section_id", sectionId);

      const html = await fetch(url).then((res) => res.text());
      const doc = new DOMParser().parseFromString(html, "text/html");

      doc
        .querySelectorAll("#ProductGridContainer > *")
        .forEach((node) => grid.appendChild(node));

      const hasMore = doc.querySelector('.pagination [rel="next"]');
      if (hasMore) {
        observer.observe(sentinel);
      } else {
        sentinel.remove();
      }
    } catch (err) {
      console.error("Infinite scroll error:", err);
      observer.observe(sentinel);
    } finally {
      loading = false;
    }
  }
});
